import { About, Project, Skill } from "../App.props"
import { githubProfile } from "./constants"

export const skillData: Skill[] = [
  { name: "React", imgURL: "/logos_react.svg", url: "https://react.dev/" },
  { name: "Next.js", imgURL: "/logo_next.svg", url: "https://nextjs.org/" },
  { name: "Vue", imgURL: "/vuedotjs-color.svg", url: "https://vuejs.org/" },
  {
    name: "Typescript",
    imgURL: "/icons-typescript.svg",
    url: "https://www.typescriptlang.org/",
  },
  { name: "Redux", imgURL: "/redux-color.svg", url: "https://redux.js.org/" },
  {
    name: "React Query",
    imgURL: "/react-query.svg",
    url: "https://tanstack.com/query/latest",
  },
  { name: "Material UI", imgURL: "/logo_mui.svg", url: "https://mui.com/" },
  {
    name: "Tailwind CSS",
    imgURL: "/tailwindcss.svg",
    url: "https://tailwindcss.com/",
  },
  {
    name: "HeroUI",
    imgURL: "/heroui-color.svg",
    url: "https://www.heroui.com/",
  },
  {
    name: "Node.js",
    imgURL: "/nodedotjs-color.svg",
    url: "https://nodejs.org/",
  },
  { name: "NestJS", imgURL: "/nestjs-color.svg", url: "https://nestjs.com/" },
  {
    name: "MongoDB",
    imgURL: "/mongodb-color.svg",
    url: "https://www.mongodb.com/",
  },
  {
    name: "Express",
    imgURL: "/express-color.svg",
    url: "https://expressjs.com/",
  },
  { name: "Git", imgURL: "/logos_git.svg", url: "https://git-scm.com/" },
  {
    name: "HTML",
    imgURL: "/icons_html.svg",
    url: "https://developer.mozilla.org/en-US/docs/Web/HTML",
  },
  {
    name: "CSS",
    imgURL: "/icons_css.svg",
    url: "https://developer.mozilla.org/en-US/docs/Web/CSS",
  },
  {
    name: "Javascript",
    imgURL: "/icons_js.svg",
    url: "https://developer.mozilla.org/en-US/docs/Web/JavaScript",
  },
  { name: "jQuery", imgURL: "/jquery-color.svg", url: "https://jquery.com/" },
]

export const projectData: Project[] = [
  {
    name: "Nilkanthmart | E-Commerce App",
    description:
      "It is an e-commerce web application made using Next.js, Material UI and Redux Toolkit. Customers can browse products, add items to the cart, adjust quantities, remove products, apply coupon codes, place orders, and view order history.",
    projectURL: "https://nilkanthmart-ecommerce.vercel.app/",
    githubURL: `${githubProfile}/ecommerce-app`,
    imgURL: "/ecommerce-app.png",
  },
  {
    name: "Pokédex",
    description:
      "A pokedex website that allows users to search and view information about various Pokémon characters. A fuzzy search feature is present on the home page. User can view more details by clicking on the particular pokémon.",
    projectURL: "https://my-pokedex-nilkanth.vercel.app/",
    githubURL: `${githubProfile}/my-pokedex`,
    imgURL: "/pokedex.png",
  },
  {
    name: "Pizzeria",
    description:
      "Pizzeria is a MEAN Stack web application, where users order pizza online. Users can choose from the existing menu and order pizzas, also they can also customize their pizza by choosing ingredients.",
    projectURL: "",
    githubURL: `${githubProfile}/Pizzeria`,
    imgURL: "/pizzeria.jpg",
  },
]

const experienceInYears =
  (new Date().getTime() - new Date("2020-12-04").getTime()) /
  (1000 * 60 * 60 * 24 * 365.25)
const roundedExperience = Math.floor(experienceInYears * 2) / 2

export const experience = `${roundedExperience}+ ${roundedExperience === 1 ? "year" : "years"}`

export const aboutData: About = {
  badges: [
    {
      imgURL: "/aws-certified-cloud-practitioner.png",
      badgeURL:
        "https://www.credly.com/badges/41330447-cc91-4cab-b2ce-82d29552d72f/public_url",
    },
    {
      imgURL: "/microsoft-certified-power-platform-fundamentals.png",
      badgeURL:
        "https://www.credly.com/badges/1cb3e5da-1a8a-4c9a-81d0-aeb9b2a473f5/public_url",
    },
  ],
  education: {
    title: "Bachelor Of Engineering in Computer Engineering",
    grade: "9.0 CGPA",
    subtitle: "From L.D. College Of Engineering, Ahmedabad",
  },
}
